// extracted by mini-css-extract-plugin
export default {"privacyPolicyPage_h1":"PrivacyPolicyPage_privacyPolicyPage_h1__EcgI6","privacyPolicyPage_underline":"PrivacyPolicyPage_privacyPolicyPage_underline__nuGza"};